import React, { useState } from "react";
import { Button, Drawer } from "antd";
import { dentalIcons } from "../../utils-icons/dentalIcons";

const CustomDrawer = ({
  children,
  title = "",
  subtitle = "",
  open,
  onClose,
  width = 400,
  isDirty = false,
  onAddObservation,
  addObservation,
  isFromRecord = false,
}) => {
  return (
    <>
      <Drawer
        width={width}
        title={
          <div>
            <div
              style={{
                fontSize: 18,
                fontFamily: "Poppins-Regular",
                color: "#111111",
              }}
            >
              {title}
            </div>
            {subtitle !== "" && (
              <div
                style={{
                  fontSize: 14,
                  fontFamily: "Poppins-Regular",
                  color: "#555",
                  marginTop: 2,
                }}
              >
                {subtitle || "asasasas"} {/* Pass this as a new prop */}
              </div>
            )}
          </div>
        }
        onClose={onClose}
        maskClosable={isFromRecord}
        closeIcon={
          <>
            <img
              src={dentalIcons.drawerBackArrow}
              style={{ transform: "rotate(180deg)" }}
            />
          </>
        }
        headerStyle={{
          padding: "15px 5px",
          fontSize: 18,
          fontFamily: "Poppins-Regular",
          color: "#111111",
          width: width,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        open={open}
        style={{
          borderTopLeftRadius: "16px !important", // top-left border radius
          borderBottomLeftRadius: "16px !important", // bottom-left border radius
        }}
      >
        {isDirty && !addObservation && (
          <div
            style={{
              position: "absolute",
              right: 15,
              top: 15,
              color: "#20C3FF",
              fontSize: 16,
              fontFamily: "Poppins-Medium",
              cursor: "pointer",
            }}
            onClick={onAddObservation}
          >
            <img src={dentalIcons.createNewProject} />
            Add
          </div>
        )}
        {children}
      </Drawer>
    </>
  );
};

export default CustomDrawer;
